import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { PanelContext } from './PanelContext'

interface PanelContextProviderProps {
  children?: React.ReactNode
}

export const PanelContextProvider: React.FC<PanelContextProviderProps> = ({
  children,
}) => {
  const { t } = useTranslation()
  const [ids, setIds] = useState<string[]>([])

  // Watch out for navigation
  // If the user navigates to new site
  // the id's must be removed otherwise the
  // panel will be still be open
  let location = useLocation()

  useEffect(() => {
    removeAllIds()
  }, [location])

  const addId = (newId: string) => {
    setIds([...ids, newId])
  }

  const removeId = (idToRemove: string) => {
    setIds(ids.filter(id => id !== idToRemove))
  }

  const removeAllIds = () => {
    setIds([])
  }

  const isEdit = (idToCheck: string) => {
    return ids.includes(idToCheck)
  }

  return (
    <PanelContext.Provider
      value={{ ids, addId, removeId, removeAllIds, isEdit }}
    >
      <>{children}</>
    </PanelContext.Provider>
  )
}
